import $ from 'jquery'

$('#js-burger-toggle').click(function() {
  $('#js-header').toggleClass('js-active')
})

$("a[href^='#']").click(function() {
  var speed = 500
  var href = $(this).attr('href')
  var target = $(href == '#' || href == '' ? 'html' : href)
  var position = target.offset().top
  $('body,html').animate(
    {
      scrollTop: position
    },
    speed,
    'swing'
  )
  return false
})

$('.js-location').each(function() {
  var $href = $(this).attr('href')
  if (location.href.match($href)) {
    $(this).addClass('js-active')
  } else {
    $(this).removeClass('js-active')
  }
})

$(window).scroll(function() {
  $('.js-effect').each(function() {
    var Pos = $(this).offset().top
    var scroll = $(window).scrollTop()
    var windowHeight = $(window).height()
    if (scroll > Pos - windowHeight + windowHeight / 4) {
      $(this).addClass('js-action')
    }
  })
})
